import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Category} from "../../Models/category";
import {CategoryService} from "../../Services/category.service";
import {expansionAnimation} from "../../shared/Animations/expansion.animation";
import {WissalstoreService} from "../../Services/wissalstore.service";

@Component({
    selector: 'app-sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    styleUrls: ['./sidebar-menu.component.scss'],
    animations: [expansionAnimation],
    standalone: false
})
export class SidebarMenuComponent implements OnInit {
  categories?: Category[];
  selectedCategoryId?: number | null; 
  selectedsubCategoryId? :number | null;
  @Output() onClose = new EventEmitter<boolean>();

  constructor(private categoryService :CategoryService,
              public wissalStoreService: WissalstoreService,
             ) {

    this.categoryService.categories.subscribe((categories: Category[]) => this.categories = categories);

  }



  ngOnInit(): void {
  }

  get parentCategories(): Category[] {
    return this.categories!.filter((category) => category.parentId === null)
  }

  selectCategory(categoryId: number) {
    if (categoryId === this.selectedCategoryId) {
      this.selectedCategoryId = null;
    } else {
      this.selectedCategoryId = categoryId;
    }
  }

  selectSubCategory(categoryId: number) {
    if (categoryId === this.selectedsubCategoryId) {
      this.selectedsubCategoryId = null;
    } else {
      this.selectedsubCategoryId = categoryId;
    }
  }

  subCategories(selectedCategoryId :number): Category[] {
    return this.categories!.filter(category => category.parentId === selectedCategoryId)
  }
}
